
import { http } from './request/manage.js'
import { Toast } from 'vant';
import Router from '@/router'

// !判空
export const $isEmpty = function (val) {
  if (val === null || val === undefined || val === "") {
    return true;
  } else {
    return false;
  }
}

// !把带T的时间去除T
export const $handleTimeWithT = function (val) {
  if (val.indexOf('T') != -1) {
    return val.replace('T', ' ')
  } else {
    return val
  }
}

// !图片预览
import { ImagePreview } from 'vant';
export const $handlePreview = function (url) {
  if ($isEmpty(url)) {
    Toast("暂无图片");
    return;
  }
  var urlArr = [];
  if (Array.isArray(url)) {
    urlArr = url;
  } else {
    urlArr.push(url)
  }
  ImagePreview(urlArr);
}

// !获取滚动条当前的位置(被卷去部分)
export const $getScrollTop = () => {
  let scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  return Math.ceil(scrollTop);
}

// !获取当前可视范围的高度
export const $getClientHeight = () => {
  let clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
  } else {
    clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
  }
  return clientHeight;
}

// !获取文档完整的高度
export const $getScrollHeight = () => {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
}

//!获取url 参数
export const $getUrlKey = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

//!获取code
export const getCode = function (mode) {
  var openid = window.localStorage.getItem($isEmpty(mode) ? 'openid' : `openid_${mode}`);
  if (!openid) {//如果本地不存在openid，则通过code获取
    let urlNow = encodeURIComponent(window.location.href);
    // let urlNow = encodeURIComponent('http://dltccym.clouparking.cn/plateCarNum/noNumCarIn?bsid=448&laneid=21&mode=fcyytcc');
    let scope = 'snsapi_base'; //snsapi_userinfo //静默授权 用户无感知
    let appid = 'wxc8b99294f8e2fad5';//默认为顺峰山的appid和openid
    if (!$isEmpty(mode)) {
      appid = $getParkingInfo(mode).appid;
    }
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;
    window.location.href = url;
  } else {//否则返回openid
    return openid;
  }
}

//!获取openId
export const $getOpenId = function (code, mode) {
  return new Promise((resolve, reject) => {
    var openid = window.localStorage.getItem($isEmpty(mode) ? 'openid' : `openid_${mode}`);
    if (openid) {//本地存在openid则直接返回
      resolve(openid)
    } else {//否则通过code获取
      if (code) {//如果code存在则请求后台获取openid
        var data = { code };//默认为顺峰山的appid和openid
        if (!$isEmpty(mode)) {//非顺峰山、容桂
          data = { code, parkingid: $getParkingInfo(mode).parkingId }
        }
        http.post('/Parking/GetOpenid', data).then(res => {
          window.localStorage.setItem($isEmpty(mode) ? 'openid' : `openid_${mode}`, res.data.Data.openid)
          resolve(res.data.Data.openid)
        }).catch(err => {
          reject(err)
        });
      } else {
        Toast("code不存在")
      }

    }

  })
}

//!处理code和openid
export const $handleCodeOpenid = function (mode) {
  return new Promise((resolve, reject) => {
    var env = judgeEnvironment(), path = Router.app._route.path,
      whiteList = ['/parkingLot/plateInput', '/parkingLot/orderDetail', '/parkingLot/paySuccess', '/fukuan/chepai/Index', '/order/orderDetail', '/order/paySuccess'];//支付宝环境下只做停车缴费部分，因其他部分需要用到openid绑定数据
    if (env == 'alipay' && whiteList.indexOf(path) != -1) {//支付宝环境
      resolve();
    } else {
      let code = $getUrlKey("code");//获取url参数code
      if (code) { //路径中存在code
        $getOpenId(code, mode).then(() => {//getOpenId中判断如果存在openid会直接返回openid
          resolve()
        }).catch((err) => {
          reject();
        })
      } else {//路径中不存在code
        if (getCode(mode)) {//调用getCode获取code，getCode中判断如果存在openid会直接返回openid
          resolve()
        }
      }
    }
  })
}

// !判断当前环境
export const judgeEnvironment = function () {
  var _UA = navigator.userAgent.toLowerCase();
  if (_UA.indexOf('micromessenger') != -1) {//微信环境
    return 'wechat';
  } else if (_UA.indexOf('alipayclient') != -1) {//支付宝环境
    return 'alipay'
  } else {
    return '';
  }
}

// !金额处理为分
export const $handleMoney = function (text) {
  if (text != null && text != undefined && text != "") {
    let arr = text.toString().split(""); //转换为字符串并去除空格
    let index = arr.indexOf('.'); //小数点位置
    let len = arr.length - 1; //总长度
    if (index != -1) {
      if (len - index == 1) { //一位小数
        return Number(text.toString().replace(".", "") + "0"); //末尾加0并转换为数字
      } else if (len - index == 2) { //两位小数
        return Number(text.toString().replace(".", "")); //去除小数点并转换为数字
      }
    } else { //整数
      return text * 100;
    }
  } else {
    return text * 1;
  }
}
// !金额保留两位小数
export const $handleMoneyFloat = function (text) {
  if (text != null && text != undefined && text != "") {
    let arr = text.toString().split(""); //转换为字符串并去除空格
    let index = arr.indexOf('.'); //小数点位置
    let len = arr.length - 1; //总长度
    if (index != -1) {
      if (len - index == 1) { //一位小数
        return text.toString() + "0"; //末尾加0并转换为数字
      } else if (len - index == 2) { //两位小数
        console.log(2)
        return text.toString(); //去除小数点并转换为数字
      }
    } else { //整数
      return text + '.00';
    }
  } else {
    return text + '.00';
  }
}


export function $hhmmss_cn (value) {
  value = value * 1000
  // 计算出相差天数
  const dayDiff = Math.floor(value / (24 * 3600 * 1000))
  // 计算出小时数
  const leave1 = value % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  const hours = Math.floor(leave1 / (3600 * 1000)) // 计算出小时数
  //计算相差分钟数
  const leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  let m = Math.floor(leave2 / (60 * 1000)) // 计算相差分钟数
  m = m < 10 ? ('0' + m) : m
  //计算相差秒数
  const leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  let s = Math.round(leave3 / 1000)
  s = s < 10 ? ('0' + s) : s
  let h = dayDiff * 24 + hours
  h = h < 10 ? ('0' + h) : h
  const res = { h, m, s }
  // return h + '小时' + m + '分钟' + s + '秒'
  return res
}


Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "D+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export function $formatDate (times, pattern) {
  var d = new Date(times).Format("YYYY-MM-DD hh:mm:ss");
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}

// !获取商家登录账号
export const $getBusinessAccount = function (type, mode) {
  const loginAccount = window.localStorage.getItem(`loginAccount_${mode}`)
  if (loginAccount) {
    return loginAccount
  } else {
    if (type === 'notAuto') {

    } else {
      Toast("请登录后使用");
      setTimeout(() => {
        this.$router.replace({ path: '/parkingBusiness/businessIndex', query: this.$route.query });
      }, 1500)
    }
    return false
  }
}

// !获取停车场信息
export const $getParkingInfo = function (mode) {
  var parkComInfo = {};
  if (!$isEmpty(mode)) {
    switch (mode) {
      case 'jinYueHongTai':
        parkComInfo = {
          logoWidth: '2.15rem',//logo宽度
          logoHeight: '3rem',//logo高度
          logo: require('@/assets/imgs/jinYueHongTaiLogo.jpg'),//logo地址
          name: '金粤宏泰大厦露天停车场',
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '收费单位：广东顺德广厦物业管理有限公司',//改为宏良建设支付主体
          parkingId: "502",//1,2,3,
          appid: "wx848e32d9ec528291",
          isRefundMonthCard: false,
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: false,
        };
        break;
      case 'bailicheng':
        parkComInfo = {
          logoWidth: '3rem',//logo宽度
          logoHeight: '3rem',//logo高度
          logo: require('@/assets/imgs/bailichengLogo.jpg'),//logo地址
          name: '百利城停车场',//停车场名称
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '收费单位：佛山市顺德区东联物业管理有限公司大良分公司',//其他-收费单位
          parkingId: "452,500301,500302",//停车场id 445,446,447
          appid: "wxb4f035b3ceb12a86",//公众号appid
          isRefundMonthCard: false,//是否能退卡
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: true,//是否需要商家系统协议
        };
        break;
      case 'YDTTestParking'://!用的百利城公众号的参数
        parkComInfo = {
          logoWidth: '3rem',//logo宽度
          logoHeight: '3rem',//logo高度
          logo: require('@/assets/imgs/logo.png'),//logo地址
          name: '新基测试停车场',//停车场名称
          technicalSupport: '©广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '',//其他-收费单位
          parkingId: "455",//停车场id 445,446,447
          appid: "wxb4f035b3ceb12a86",//公众号appid
          isRefundMonthCard: false,//是否能退卡
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: true,//是否需要商家系统协议
        };
        break;
      case 'SFMTestParking'://!用的百利城公众号的参数
        parkComInfo = {
          logoWidth: '3rem',//logo宽度
          logoHeight: '3rem',//logo高度
          logo: require('@/assets/imgs/logo.png'),//logo地址
          name: '赛菲姆测试停车场',//停车场名称
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '收费单位：广东科陆智泊信息科技有限公司',//其他-收费单位
          parkingId: "454",//停车场id 445,446,447
          appid: "wxb4f035b3ceb12a86",//公众号appid
          isRefundMonthCard: false,//是否能退卡
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: true,//是否需要商家系统协议
        };
        break;
      case 'ronggui':
        parkComInfo = {
          logo: require('@/assets/imgs/rongguiLogo.png'),
          name: '振南停车场',
          technicalSupport: '广东东菱智泊停车科技有限公司',//技术支持/版权
          otherText: '',//其他-收费单位
          parkingId: "453",//1,2,3,
          appid: "wxc8b99294f8e2fad5",
          isRefundMonthCard: false,
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: true,
        };
        break;
      case 'shunfengshan':
        parkComInfo = {
          logo: require('@/assets/imgs/shunfengshanLogo2.jpg'),
          name: '顺峰山公园停车场',
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '收费单位：佛山市顺德区宏良建设发展有限公司',//其他-收费单位
          parkingId: "",//1,2,3,
          appid: "wxc8b99294f8e2fad5",
          isRefundMonthCard: false,
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: true,
        };
        break;
      case 'fcyytcc':
        parkComInfo = {
          logo: require('@/assets/imgs/jingliangLogo.png'),
          name: '凤城停车场',
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          otherText: '收费单位：佛山市顺德区景良建设发展有限公司',//其他-收费单位
          parkingId: "448",//1,2,3,
          appid: "wx766c9d2a2930bab6",
          isRefundMonthCard: false,
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: false,
        };
        break;
      case 'guoTaiLu':
        parkComInfo = {
          logo: require('@/assets/imgs/jingliangLogo.png'),
          name: '国泰路停车场',
          technicalSupport: '技术支持：广东科陆智泊信息科技有限公司',//技术支持/版权
          //otherText: '收费单位：佛山市顺德区景良建设发展有限公司',//其他-收费单位
          otherText: '收费单位：佛山市顺德区宏良建设发展有限公司',//改为宏良建设支付主体
          parkingId: "400501",//1,2,3,
          //appid: "wx766c9d2a2930bab6",
          appid: "wxc8b99294f8e2fad5",//改为宏良建设支付主体
          isRefundMonthCard: false,
          isChangeMonthCardPlate: false,//是否能变更车牌
          hasParkingBusinessProtocol: false,
        };
        break;
    }
  }
  return parkComInfo;
}

// !获取停车场信息
export const $getParkingIdByMode = function (parkingId) {
  var mode = 'shunfengshan', parkingIdList = parkingId.split(',');
  if (parkingIdList.length > 0) {
    var id = String(parkingIdList[0]);
    if (['453'].indexOf(id) != -1) {//振南停车场
      mode = 'ronggui';
    } else if (['448'].indexOf(id) != -1) {//凤城影院停车场
      mode = 'fcyytcc';
    } else if (['452', '500301', '500302'].indexOf(id) != -1) {//百利城停车场
      mode = 'bailicheng';
    } else if (['454'].indexOf(id) != -1) {//赛菲姆测试停车场
      mode = 'SFMTestParking';
    } else if (['455'].indexOf(id) != -1) {//新基测试停车场
      mode = 'YDTTestParking';
    } else if (['400501'].indexOf(id) != -1) {//国泰路停车场
      mode = 'guoTaiLu';
    } else if (['502'].indexOf(id) != -1) {//金粤宏泰停车场
      mode = 'jinYueHongTai';
    } else {
      mode = 'shunfengshan';
    }
  }
  return mode;
}



// WEBPACK FOOTER //
// ./src/utils/index.js